import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logAPIError } from '../../../utils/logger';
import { errorMessage } from './constants';

/**
 * Duplicate  draft project
 * @param {String} draftId - id of draft
 * @param {String} uid - user uid
 * @param {String} platform - user platform
 * @returns {Promise<{void}>}
 */
const duplicateDraftProject = async(draftId, uid, platform) => {
    const requestUrl = pathfinder('logo_maker_makers_copy_user_saved_draft', {
        savedDraftId: draftId
    });

    try {
        const { data } = await axios.post(requestUrl, { uid, platform });
        if (data.error) {
            throw new Error(data.error);
        }

        return data.data;
    } catch (e) {
        logAPIError(e, { message: errorMessage, draftId, uid });

        throw new Error(errorMessage);
    }
};

export default duplicateDraftProject;
